import builder from '../builder';
import MessagesBubbleSquareQuestionAlternate from '../../streamline-icons/bold/messages-bubble-square-question-alternate.svg';

export default builder(
  'IconMessagesBubbleSquareQuestionAlternateBold',
  MessagesBubbleSquareQuestionAlternate,
);
